<template>
  <GenericInputSection :title="label || ''" :required="required">
    <div class="flex relative gap-x-2 w-full h-full">
      <slot name="prefix" />
      <input
        :id="id"
        :type="type === 'number' ? 'text' : type"
        :inputmode="type === 'number' ? 'decimal' : undefined"
        :name="label"
        :class="
          classNames(
            'w-full h-fit rounded-md border-0 min-h-8 p-1.5 text-gray-900 disabled:text-gray-400 shadow-sm !ring-0 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6',
            props.isLoading && 'pr-10',
          )
        "
        :value="props.modelValue"
        v-bind="$attrs"
        @input="
          (evt: Event) => {
            if (!evt.target) return;

            const evtTarget = evt.target as HTMLInputElement;

            if (
              type === 'number' &&
              evtTarget.value !== '' &&
              !isNaN(Number(evtTarget.value))
            ) {
              emit('update:modelValue', Number(evtTarget.value));
            } else {
              emit('update:modelValue', evtTarget.value);
            }
          }
        "
      />
      <div
        v-if="props.isLoading"
        class="flex absolute inset-y-0 right-0 items-center pr-3"
      >
        <Loader class="w-5 h-5 text-gray-500 animate-spin" />
      </div>
      <slot name="suffix" />
    </div>
  </GenericInputSection>
</template>
<script lang="ts" setup>
import { random } from "lodash-es";
import { Loader } from "lucide-vue-next";

defineOptions({
  inheritAttrs: false,
});

const emit = defineEmits<{
  (e: "update:modelValue", value: any): void;
}>();

const props = defineProps<{
  modelValue: unknown;
  label?: string;
  id?: string;
  type?: HTMLInputElement["type"];
  isLoading?: boolean;
  required?: boolean;
}>();

const id = computed(() => props.id || `${props.label}-${random(0, 10000)}`);
</script>
